import { TeamAccessEditDTO } from '../team/team-access-edit.dto';
import { IsNotEmpty, MaxLength, IsString, IsOptional, IsUUID, IsInt, IsArray, MinLength } from 'class-validator';

export class WikiCategoryEditDTO extends TeamAccessEditDTO {

    @IsNotEmpty()
    @IsString()
    @MaxLength(255)
    name: string;

    @IsOptional()
    @IsString()
    description: string;

    @IsOptional()
    @IsUUID()
    parent: string;

    @IsOptional()
    @IsInt()
    sortOrder: number;

    @IsOptional()
    @IsArray()
    @IsString({
        each: true
    })
    @MinLength(36, {
        each: true
    })
    @MaxLength(36, {
        each: true
    })
    posts: Array<string>;

}
